export const GENERAL_ERROR_MSG =
  'Something went wrong. Please refresh the page and try again.';
export const REDIRECT_ERROR_MSG =
  "We're redirecting you to sign in to your account.";
export const TECHNICAL_ERROR_MSG =
  "We're sorry. There was a temporary technical error. Please try again later.";
export const IDME_ERROR_HEADLINE = 'Something went wrong';
export const IDME_ERROR_MSG =
  'Refresh the page to verify your military affiliation with ID.me.';
export const IDME_INELIGIBLE_HEADLINE = 'Verification incomplete';
/* The rest of this message carries a link, so it lives as JSX in
/* components/IdmeVerification/IneligibilityMessage.jsx rather than here. */
export const IDME_INELIGIBLE_LINK_LABEL = 'FAQ';
export const IDME_SUCCESS_MSG = 'Verification successful';
